import {get} from "$lib/api";

export const getReference = async (type: string) => {
    return await get(`/hr/reference/${type}`);
}
export const getHrTodos = async () => {
    return await get('/hr/todos');
}
